module.exports = __webpack_public_path__ + "static/hr_capabilities_1-a07a7583e8ef6c17c2400c247f1b5f92.png";